export enum TransactionSortProperty {
  EntryDate = 'entryDate',
  TransactionNo = 'transactionNo',
  VoucherNo = 'voucherNo',
  HasVoucher = 'hasVoucher',
}
